import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import BaseComponent from '../base.component';
import { ICON_OPTIONS, IconOption, icoSearchFn } from '../../constants/app-icons';

@Component({
    selector: 'cdp-icon-selector',
    templateUrl: './icon-selector.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IconSelectorComponent),
            multi: true
        }
    ],
    standalone: false
})
export class IconSelectorComponent extends BaseComponent implements ControlValueAccessor {
    @Input() icon = '';
    @Input() showDescription = true;
    public iconOptions = ICON_OPTIONS;
    public searchIconFn = icoSearchFn;
    public readonly iconInitialsName = 'initials';

    // ControlValueAccessor
    public onChange: (value: any) => void = () => undefined;
    public onTouch: () => any = () => undefined;
    public writeValue(model: string): void {
        this.icon = model;
    }
    public registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => any): void {
        this.onTouch = fn;
    }

    onChangeIcon(icon: IconOption) {
        this.onChange(icon?.icon || '');
    }
}
